(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .constant('SSO_LOGIN_DATA', function () {
            var constant = {
                other: {id: 0, title: 'Plagiat.pl ADFS'},
                valencia: {id: 1, title: 'Universitat de València'},
                sdu: {id: 2, title: 'University of Southern Denmark, SDU'},
                tartu: {id: 3, title: 'University of Tartu'},
                tallinn: {id: 4, title: 'Tallinn University'},
                tusofia: {id: 5, title: 'TU Sofia'},
                taltech: {id: 6, title: 'Tallinna Tehnikaülikool'},
                unibit: {id: 7, title: 'unibit.bg'},
                tampere: {id: 8, title: 'Tampere Secondary Education'},
                valladolid: {id: 9, title: 'Universidad de Valladolid'},
                chevron: {id: 10, title: 'Chevron College'},
                ilmenau: {id: 11, title: 'Technische Universität Ilmenau'},
                jaen: {id: 12, title: 'Universidad de Jaén'},
                eah_jena_de: {id: 13, title: 'Ernst Abbe University of Applied Sciences Jena'},
                hochschule: {id: 14, title: 'Hochschule Nordhausen'},
                eesc: {id: 15, title: 'European Economic and Social Committee (EESC)'},
                eesc2: {id: 16, title: 'European Committee of the Regions (CoR)'},
                hepl: {id: 17, title: 'Haute Ecole de la Province de Liège (HEPL)'},
                lviv: {id: 18, title: 'Lviv State University of Life Safety'},
                gottingen: {id: 19, title: 'AcademicID'},
                bfg: {id: 20, title: 'BFG, Bezpieczny Bank'},
                castilla: {id: 21, title: 'Universidad de Castilla-La Mancha'},
                google: {id: 22, title: 'Google SSO'},
                googlelanding: {id: 23, title: 'Google SSO'},
                salta: {id: 24, title: 'Salta Group'},
                saxony: {id: 25, title: 'Duale Hochschule Sachsen'},
            };

            return constant;
        }())
})();
